module.exports = __webpack_public_path__ + "static/showroomBottles-2c7e1b68285733d4a7be40b7bb448490.jpg";